import React from 'react';
import { questionOptions } from '../../data/teaser';
interface ScreenQuestionProps {
  onAnswer: (answer: string) => void;
}
export function ScreenQuestion({
  onAnswer
}: ScreenQuestionProps) {
  return <section className="flex h-full w-full flex-col justify-center" data-id="element-76" data-mp="ytt2acuxb6e">
      <h1 className="text-center text-4xl font-extrabold leading-tight text-white animate-fade-in-up" data-id="element-77" data-mp="3sd9fchdnh1xp">
        Still creating attachments chairside?
      </h1>

      <div className="mt-12 flex flex-col gap-4" data-id="element-78" data-mp="av6n59cbdr1o">
        {questionOptions.map((option, index) => <button key={option} onClick={() => onAnswer(option)} className="w-full rounded-2xl border border-solventum-primary/60 bg-white/[0.03] px-6 py-7 font-headline text-2xl font-bold text-white transition-colors duration-150 hover:border-solventum-primary hover:bg-white/[0.06] active:scale-[0.99] opacity-0-init animate-rise-in" style={{
        animationDelay: `${140 + index * 110}ms`
      }} data-id="element-79" data-mp="5xevmgfl06y0" data-mpi={index}>
            {option}
          </button>)}
      </div>
    </section>;
}